import { useEffect, useRef } from 'react';

import socketService from '../../domain/services/api/socket';

const WORK_SIGNAL_EVENT = 'seller:work-signal';
const WORK_SIGNAL_INTERVAL_MS = 60000;
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'wheel'];

const isPageVisible = () => document.visibilityState === 'visible';

const useSellerWorkSignal = (enabled) => {
    const lastSentAtRef = useRef(0);
    const pendingSinceRef = useRef(0);

    useEffect(() => {
        if (!enabled)
            return undefined;

        const sendWorkSignal = () => {
            if (!isPageVisible())
                return;

            const now = Date.now();
            if (now - lastSentAtRef.current < WORK_SIGNAL_INTERVAL_MS)
                return;

            if (!socketService.emit(WORK_SIGNAL_EVENT)) {
                pendingSinceRef.current = pendingSinceRef.current || now;
                return;
            }

            lastSentAtRef.current = now;
            pendingSinceRef.current = 0;
        };

        const onVisibilityChange = () => {
            if (isPageVisible())
                sendWorkSignal();
        };

        const onConnect = () => {
            const pendingSince = pendingSinceRef.current;
            pendingSinceRef.current = 0;

            if (pendingSince && Date.now() - pendingSince < WORK_SIGNAL_INTERVAL_MS)
                sendWorkSignal();
        };

        sendWorkSignal();

        const unsubscribeConnect = socketService.subscribe('connect', onConnect);
        document.addEventListener('visibilitychange', onVisibilityChange);
        window.addEventListener('focus', sendWorkSignal);
        INTERACTION_EVENTS.forEach(event => window.addEventListener(event, sendWorkSignal, { capture: true, passive: true }));

        return () => {
            unsubscribeConnect();
            document.removeEventListener('visibilitychange', onVisibilityChange);
            window.removeEventListener('focus', sendWorkSignal);
            INTERACTION_EVENTS.forEach(event => window.removeEventListener(event, sendWorkSignal, { capture: true }));
        };
    }, [enabled]);
};

export default useSellerWorkSignal;
